var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconVstoreSimple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 21,
    viewBox: "0 0 25 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0169 20.9876L6.42047 1.43905C6.17441 0.586278 5.41905 0 4.55498 0H0L12.0169 20.9876Z",
    fill: "url(#paint0_linear_7530_43898)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5028 19.6906L17.6757 1.29688L12.5028 10.4938L7.32404 1.29688L12.5028 19.6906Z",
    fill: "#76EFF5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0001 0L12.9832 20.9876L18.5796 1.43905C18.8257 0.586278 19.581 0 20.4451 0H25.0001Z",
    fill: "url(#paint1_linear_7530_43898)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7530_43898",
    x1: 6.00846,
    y1: 0,
    x2: 6.00846,
    y2: 20.9876,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#60BFF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#101434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_7530_43898",
    x1: 18.9916,
    y1: 0,
    x2: 18.9916,
    y2: 20.9876,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#60BFF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#101434"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVstoreSimple);
export default __webpack_public_path__ + "static/media/icon_vstore_simple.19d0a8416ab3d721206d90e73612457e.svg";
export { ForwardRef as ReactComponent };